<ion-header *ngIf="getSerieFailed || getQuestionFailed || getSessionsFailed || getSessionFailed">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content [scrollEvents]="true">

  <bloc-header-comp *ngIf="!getSerieFailed && !getQuestionFailed && !getSessionsFailed && !getSessionFailed" [compOptions]="{
    'title': blocHeaderTitle,
    isBackBtn: true,
    url: 'quitSerie',
    withOutputClose: 'quitSerie',
    isDesktop: !isDesktop,
    loading: !serie,
    showLoaderBar: true,
    showMute: true,
    muted: isMuted,
    loaderBarPercent: percentProgression,
    serie: serie
  }" (outputHeader)="triggerActionById($event)"></bloc-header-comp>

  <bloc-header-comp class="serie-failed" *ngIf="getSerieFailed || getQuestionFailed || getSessionFailed" [compOptions]="{'title': 'Retour', isBackBtn: true, url: serieType === 'erreurs' ? 'code' : 'series/' + serieType}"></bloc-header-comp>

  <!-- SERIE -->
  <div *ngIf="!getSerieFailed && !getQuestionFailed && !getSessionsFailed && !getSessionFailed" [ngClass]="{'padding-h-20': isDesktop}">
    <div *ngIf="!!questionForm" class="serie-container">
      <div *ngIf="isDesktop" class="top-nav-serie">
        <img class="close-btn small-clickable" src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24" (click)="quitSerie()">
        <span class="serie-title">{{blocHeaderTitle}}</span>
        <div class="sound-btn small-clickable" (click)="muteMedia()">
          <img *ngIf="!isMuted" src="assets/2022/icons/volume-up-off.svg" alt="EnVoitureSimone">
          <img *ngIf="isMuted" src="assets/2022/icons/volume-off-off.svg" alt="EnVoitureSimone">
        </div>
      </div>
      <loader-bar-comp *ngIf="isDesktop" class="bottom-shadow" [compOptions]="{'percent': percentProgression}"></loader-bar-comp>
      <div class="evs-card-ui content-serie" [ngClass]="{'serie-enable-user-select': isDesktop && !isCordova}">
        <div class="media-container" #mediaContainer>
          <media-comp class="media-comp" *ngIf="type === 'question'" [compOptions]="{question: question, debug: isDebug, mode: 'entrainement', scope: type, pause: isPaused, mute: isMuted, stop: isStoped, reload: isReloaded, serieType: serieType}" (mediaEvent)='handleMediaEvent($event)' (failEvent)="handleMediaFailEvent($event)" (isFullscreen)="setMediaIsFullscreen($event)"></media-comp>
          <media-comp class="media-comp" *ngIf="type === 'answer'" [compOptions]="{question: question, debug: isDebug, mode: 'entrainement', scope: type, pause: isPaused, mute: isMuted, stop: isStoped, reload: isReloaded, serieType: serieType}" (mediaEvent)='handleMediaEvent($event)' (failEvent)="handleMediaFailEvent($event)" (isFullscreen)="setMediaIsFullscreen($event)"></media-comp>
          <div class="reload-btn" (click)="reloadMedia()" *ngIf="showReloadBtn">
            <img src="assets/2022/icons/reload.svg" alt="EnVoitureSimone">
          </div>
        </div>
        <div class="padding-16">
          <div class="questions-container" *ngIf="!showAnswers">
            <form [formGroup]="questionForm" (ngSubmit)="submitAnswer()">
              <h5 class="question">{{question.question_text}}</h5>
              <p class="nb-answers-possible" *ngIf="question.correctAnswers.length === 1">(Une réponse possible)</p>
              <p class="nb-answers-possible" *ngIf="question.correctAnswers.length > 1">(Plusieurs réponses possibles)</p>
              <ng-container *ngFor="let field of dynamicFormData; let i = index">
                <div *ngIf="!!field.text" class="sub-question margin-bottom-16" [ngClass]="{'margin-top-24': i > 0}">{{field.text}}</div>
                <ng-container *ngFor="let option of field.possible_values; let j = index">
                  <input type="checkbox" [id]="field.field_name + '_' + option.value">
                  <label class="evs-card" [ngClass]="{'light': isDesktop, 'margin-top-8': j > 0, 'no-hover': !isDesktop}" [for]="field.field_name + '_' + option.value" (click)="onCheckboxesChange({field: field.field_name, value: option.value})">
                    <span class="value-label">{{option.value}}</span>
                    <span class="value-text">{{option.text}}</span>
                  </label>
                </ng-container>
              </ng-container>
              <!-- <loading-button-comp *ngIf="serieType === 'entrainements'" class="wpe-100 margin-top-30" [compOptions]="{loading: sendingAnswer, type: 'submit', disabled: !questionForm.valid}"></loading-button-comp> -->
              <loading-button-comp *ngIf="serieType != 'examens'" class="wpe-100 margin-top-32" [compOptions]="{loading: sendingAnswer, type: 'submit', disabled: serieLockedForGuest}"></loading-button-comp>
              <button *ngIf="serieType === 'examens'" type="submit" class="btn full-width margin-top-32 progress-wrap" [disabled]="sendingAnswer || serieLockedForGuest">
                <div class="progress-bar" #timerBtn></div>
                <div class="progress-text">Valider</div>
              </button>
            </form>
          </div>
          <div class="answers-container" *ngIf="showAnswers">
            <div class="answers-controls">
              <b>Réponse : 
                <ng-container *ngFor="let item of question.correctAnswers; let i = index">
                  <ng-container *ngIf="i < (question.correctAnswers.length - 1) && i > 0"><span class="text-orange-500">, </span></ng-container>
                  <ng-container *ngIf="i == (question.correctAnswers.length - 1) && question.correctAnswers.length > 1"><span class="text-orange-500"> et </span></ng-container>
                  <span class="text-orange-500">{{item | uppercase}}</span>
                </ng-container>
              </b>
              <button class="btn" [ngClass]="{'light': showCorrection, 'white': (showCorrection && !isDesktop)}" (click)="toggleCorrection()">
                <span *ngIf="!showCorrection">Réponse<ng-container *ngIf="question.correctAnswers.length > 1">s</ng-container></span>
                <span *ngIf="showCorrection">&Eacute;noncé</span>
              </button>
            </div>
            <h5 *ngIf="!showCorrection" class="question">{{question.question_text}}</h5>
            <ng-container *ngFor="let field of dynamicFormData; let i = index">
              <div *ngIf="!showCorrection && !!field.text" class="sub-question" [ngClass]="{'margin-top-20': i > 0}">{{field.text}}</div>
              <ng-container *ngFor="let values of field.possible_values; let j = index">
                <label class="evs-card-ui" [ngClass]="{'light': isDesktop, 'selected': !showCorrection && isAnswered(values.value, questionForm.value['question'+(i+1)]), 'no-hover': showCorrection || !isAnswered(values.value, questionForm.value['question'+(i+1)]), 'goodAnswer': !showCorrection && isUserValidAnswer(values.value, questionForm.value['question'+(i+1)]) === 'ok', 'wrongAnswer': !showCorrection && isUserValidAnswer(values.value, questionForm.value['question'+(i+1)]) === 'ko'}" *ngIf="(showCorrection && isUserValidAnswer(values.value, [values.value]) === 'ok') || !showCorrection">
                  <span class="value-label">{{values.value}}</span>
                  <span class="value-text-with-icon">{{values.text}}</span>
                  <div class="ico-good-answer" *ngIf="!showCorrection && isUserValidAnswer(values.value, questionForm.value['question'+(i+1)]) === 'ok'"></div>
                  <div class="ico-wrong-answer" *ngIf="!showCorrection && isUserValidAnswer(values.value, questionForm.value['question'+(i+1)]) === 'ko'"></div>
                  <div class="ico-good-answer" *ngIf="!showCorrection && isValidAnswer(values.value) === 'ok' && isUserValidAnswer(values.value, questionForm.value['question'+(i+1)]) !== 'ko'"></div>
                </label>
              </ng-container>
            </ng-container>
            <div class="correction-container" *ngIf="showCorrection">
              <p *ngFor="let correction of question.correction">{{correction}}</p>
              <div class="content-center" *ngIf="!canZendesk">
                <button class="btn" (click)="openLink('zendesk')">Un doute ?<br>Nos experts te répondent</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="margin-top-16" *ngIf="getSerieFailed || getQuestionFailed || getSessionsFailed || getSessionFailed">
    <bloc-error-comp></bloc-error-comp>
  </div>

  <!-- MODAL MAJ CODE 2023 -->
  <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayMajCode2023">
    <div class="text-box">
      <h4 class="title">Nouvelles questions disponibles !</h4>
      <p class="text">Clique sur “Mettre à jour” et découvre nos nouvelles séries et questions, toujours 100% conformes à l’examen 👌</p>
    </div>
    <div class="button">
      <button class="btn full-width" (click)="majCode2023(false)">Mettre à jour
        <ion-spinner *ngIf="showSpiner" class="custom-spinner" name="crescent"></ion-spinner>
      </button>
    </div>
  </modal-comp>

  <!-- MODAL RESTART CODE 2023 -->
  <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayRestartCode2023">
    <div class="text-box">
      <h4 class="title">Nouvelles questions disponibles !</h4>
      <p class="text">Redémarre ton application pour afficher les nouvelles questions de code.<br>Tes sessions seront remises à jour.</p>
    </div>
    <div class="button">
      <button class="btn full-width" (click)="restartCode2023()">Redémarrer l'app</button>
    </div>
  </modal-comp>

  <!-- MODAL ERROR CODE 2023 -->
  <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayErrorCode2023">
    <div class="text-box">
      <h4 class="title">Une erreur est survenue</h4>
      <p class="text">Essaye à nouveau de mettre à jour l’application<br>{{majCallError}}</p>
    </div>
    <div class="button">
      <button class="btn full-width" (click)="majCode2023(false)">Mettre à jour
        <ion-spinner *ngIf="showSpiner" class="custom-spinner" name="crescent"></ion-spinner>
      </button>
    </div>
  </modal-comp>

  <!-- MODAL DRIVING TRAINING MAJ CODE 2023 -->
  <!-- <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayDrivingTrainingMajCode2023">
    <div class="text-box">
      <h4 class="title">Nouvelles questions disponibles !</h4>
      <p class="text">Clique sur “Mettre à jour” et découvre nos nouvelles séries et questions, toujours 100% conformes à l’examen 👌</p>
    </div>
    <div class="button">
      <button class="btn light full-width margin-bottom-8" (click)="majCode2023(true)">Annuler</button>
      <button class="btn full-width" (click)="majCode2023(false)">Mettre à jour
        <ion-spinner *ngIf="showSpiner" class="custom-spinner" name="crescent"></ion-spinner>
      </button>
    </div>
  </modal-comp> -->

  <!-- CLEAN SESSION -->
  <modal-comp [compOptions]="{'id': 'customModalDeleteSession', closable: false}"  *ngIf="displayModalDeleteSession">
    <div class="text-center">
      <p class="bold">Oups, une erreur est survenue</p>
      <p class="margin-0 margin-top-10">Rien de grave&nbsp;! Nous allons remettre les compteurs à zéro pour que tu puisses recommencer ta série d’entraînement.</p>
      <div class="margin-top-20">
        <button class="btn full-width" (click)="deleteSessions()">J'ai compris</button>
      </div>
    </div>
  </modal-comp>

  <!-- END FIRST SERIE -->
  <modal-comp [compOptions]="{'id': 'customModalEndFirstSerie', size: (!isDesktop) ? 'large' : '', dynamicHeight: true}" *ngIf="displayModalEndFirstSerie" (canClose)="hideModalEndFirstSerie()" #modalEndFirstSerie>
    <div class="text-center padding-v-5">
      <p><b>Félicitations,</b><br>tu viens de terminer ta toute première série d'entraînement&nbsp;!</p>
      <div class="margin-top-20">
        <button class="btn full-width" (click)="hideModalEndFirstSerie('details')">Détails de mes résultats</button>
        <button class="btn light full-width margin-top-20" (click)="hideModalEndFirstSerie('nextSerie')">Série suivante</button>
      </div>
    </div>
  </modal-comp>

  <!-- PUB CPF -->
  <modal-comp [compOptions]="{'id': 'customModalPubCpf', size: (!isDesktop) ? 'full' : 'large', dynamicHeight: true, closable: false}" *ngIf="displayModalPubCpf" (canClose)="hideModalPubCpf()" #modalPubCpf>
    <div class="pub-content text-center padding-v-5">
      <div class="logo margin-top-30 margin-bottom-23">
        <img src="assets/svg/logo-border-name.svg" alt="EnVoitureSimone">
      </div>
      <p class="margin-bottom-41"><b>Financez votre permis<br>avec le CPF&nbsp;!</b></p>
      <div class="asset margin-bottom-41">
        <img src="assets/svg/asset-lecons.svg" alt="EnVoitureSimone">
      </div>
      <div class="button-box">
        <button class="btn full-width" (click)="hideModalPubCpf('details')">En savoir plus</button>
        <button *ngIf="!userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubCpf('nextSerie')">Continuer ma série</button>
        <button *ngIf="userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubCpf('nextSerie')">Faire une autre série</button>
      </div>
    </div>
  </modal-comp>

  <!-- PUB BVA -->
  <modal-comp [compOptions]="{'id': 'customModalPubBva', size: (!isDesktop) ? 'full' : 'large', dynamicHeight: true, closable: false}" *ngIf="displayModalPubBva" (canClose)="hideModalPubBva()" #modalPubBva>
    <div class="pub-content text-center padding-v-5">
      <div class="logo margin-top-30 margin-bottom-23">
        <img src="assets/svg/logo-border-name.svg" alt="EnVoitureSimone">
      </div>
      <p class="margin-bottom-41"><b>Le permis sans les galères,</b><br>dès <b>599€</b>&nbsp;🎉</p>
      <div class="asset margin-bottom-41">
        <img src="assets/svg/asset-lecons.svg" alt="EnVoitureSimone">
      </div>
      <div class="button-box">
        <button class="btn full-width" (click)="hideModalPubBva('details')">En savoir plus</button>
        <button *ngIf="!userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubBva('nextSerie')">Continuer ma série</button>
        <button *ngIf="userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubBva('nextSerie')">Faire une autre série</button>
      </div>
    </div>
  </modal-comp>

    <!-- PUB BDC -->
    <modal-comp [compOptions]="{'id': 'customModalPubBdc', size: (!isDesktop) ? 'full' : 'large', dynamicHeight: true, closable: false}" *ngIf="displayModalPubBdc" (canClose)="hideModalPubBdc()" #modalPubBdc>
      <div class="pub-content text-center padding-v-5">
        <div class="logo margin-top-30 margin-bottom-23">
          <img src="assets/svg/logo-border-name.svg" alt="EnVoitureSimone">
        </div>
        <p class="margin-bottom-41"><b>Envie d'avancer ? <br/>On vous rappelle !</b></p>
        <div class="asset margin-bottom-41">
          <img src="assets/svg/asset-call-party.svg" alt="EnVoitureSimone">
        </div>
        <div class="button-box">
          <button class="btn full-width" (click)="hideModalPubBdc('details')">Être rappelé</button>
          <button *ngIf="!userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubBdc('nextSerie')">Continuer ma série</button>
          <button *ngIf="userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubBdc('nextSerie')">Faire une autre série</button>
        </div>
      </div>
    </modal-comp>

  <!-- PUB Pack Permis -->
  <modal-comp [compOptions]="{'id': 'customModalPubPackPermis', size: (!isDesktop) ? 'full' : 'large', dynamicHeight: true, closable: false}" *ngIf="displayModalPubPackPermis" (canClose)="hideModalPubPackPermis()" #modalPubPackPermis>
    <div class="pub-content text-center padding-v-5">
      <div class="logo margin-top-30 margin-bottom-23">
        <img src="assets/svg/logo-border-name.svg" alt="EnVoitureSimone">
      </div>
      <p class="margin-bottom-41"><b>Le permis sans les galères,</b><br>dès <b>749€</b>&nbsp;🎉</p>
      <div class="asset margin-bottom-41">
        <img src="assets/svg/asset-lecons.svg" alt="EnVoitureSimone">
      </div>
      <div class="button-box">
        <button class="btn full-width" (click)="hideModalPubPackPermis('details')">En savoir plus</button>
        <button *ngIf="!userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubPackPermis('nextSerie')">Continuer ma série</button>
        <button *ngIf="userLifeCycle.isUserGuest" class="btn light full-width margin-top-20" (click)="hideModalPubPackPermis('nextSerie')">Faire une autre série</button>
      </div>
    </div>
  </modal-comp>

  <!-- STRIKE 2 -->
  <modal-comp [compOptions]="{'id': 'customModalStrike2'}" *ngIf="displayModalStrike2" (canClose)="hideModalStrike2()" #modalStrike2>
    <div class="text-center">
      <p><b>Super&nbsp;!</b><br/>Tu as visé juste 2 questions d'affilée.</p>
      <div class="margin-top-20">
        <button class="btn full-width" (click)="hideModalStrike2()">Continuer</button>
      </div>
    </div>
  </modal-comp>

  <!-- STRIKE 5 -->
  <modal-comp [compOptions]="{'id': 'customModalStrike5'}" *ngIf="displayModalStrike5" (canClose)="hideModalStrike5()" #modalStrike5>
    <div class="text-center">
      <p>5 bonnes réponses de suite, ça devient très sérieux&nbsp;!</p>
      <div class="margin-top-20">
        <button class="btn full-width" (click)="hideModalStrike5()">Continuer</button>
      </div>
    </div>
  </modal-comp>

  <!-- STRIKE10 -->
  <modal-comp [compOptions]="{'id': 'customModalStrike10'}" *ngIf="displayModalStrike10" (canClose)="hideModalStrike10()" #modalStrike10>
    <div class="text-center">
      <p>10 bonnes réponses de suite, ça devient très sérieux&nbsp;!</p>
      <div class="margin-top-20">
        <button class="btn full-width" (click)="hideModalStrike10()">Continuer</button>
      </div>
    </div>
  </modal-comp>

  <!-- SOUND -->
  <modal-comp [compOptions]="{'id': 'customModalSound', dynamicHeight: true}" *ngIf="displayModalSound" (canClose)="hideModalSound()" #modalSound>
    <div class="text-center">
      <ion-icon name="volume-mute"></ion-icon>
      <p>Tu préfères réviser avec le son ? Clique à tout moment sur l'icône en haut à droite pour activer le son.</p>
      <div class="margin-top-20">
        <button class="btn full-width" (click)="callHideModalSound()">J'ai compris</button>
      </div>
    </div>
  </modal-comp>
  
  <!-- PUB VIDEO -->
  <modal-comp [compOptions]="{'id': 'customModalVideo', size: 'large', closable: false}" *ngIf="displayModalVideo" (canClose)="hideModalVideo()" #modalVideo>
    <div class="pub-video">
      <video-comp class='video-html' *ngIf="!!videoSrc" [compOptions]="{src: videoSrc, pause: false, withSound: true, controls: false, timer: true, duration: 5}" (videoEvent)='handleVideoEvent($event)' (failEvent)='handleFailEvent($event)'></video-comp>
    </div>
    <div class="cta-post-video" [ngClass]="{'active': showCtaPostVideo}">
      <button class="btn full-width" (click)="handleVideoCTA()">Pack Permis</button>
    </div>
  </modal-comp>

  <!-- QUIT EXAM -->
  <modal-comp [compOptions]="{'id': 'customModalQuitExam', closable: false}" *ngIf="displayModalQuitExam" (canClose)="hideModalQuitExam()" #modalQuitExam>
    <div class="text-center">
      <h4>Souhaites-tu vraiment quitter ?</h4>
      <p>Pas d'inquiètude, tes progrès seront sauvegardés.</p>
      <div class="margin-top-30">
        <button class="btn btn-oui-non wpi-60 margin-right-10" (click)="callHideModalQuitExam(1)">Oui</button>
        <button class="btn light btn-oui-non wpi-60" (click)="callHideModalQuitExam(0)">Non</button>
      </div>
    </div>
  </modal-comp>

</ion-content>

<ion-footer *ngIf="getSerieFailed || getQuestionFailed || getSessionsFailed || getSessionFailed">
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>

<!-- STICKY -->
<div *ngIf="!isMediaFullscreen && showAnswers && !displayMajCode2023 && !displayErrorCode2023 && !displayRestartCode2023 && !displayModalPubPackPermis && !displayModalPubCpf && !displayModalPubBva && !displayModalVideo && !showCtaPostVideo && !modalShown && !showLastResultComp && (serieType == 'entrainements' || serieType == 'thematiques' || serieType == 'erreurs') && answered" class="sticky sticky-bottom sticky-white" [appScrollerInApp]="{absolute: true}" [content]="content">
  <div class="chevron-up">
    <button class="btn full-width" [ngClass]="{'bg-green-300': answeredValid}" (click)="handleNextQuestion()">Continuer</button>
  </div>
  <div class="content" [ngClass]="{'greenContent': answeredValid, 'redContent': !answeredValid}">
    <div *ngIf="canZendesk" class="questionIcon small-clickable" (click)="openLink('zendesk')">
      <div class="faq-icon"></div>
    </div>
    <div class="goodAnswer margin-left-5 fix-zendesk" *ngIf="answeredValid && (questionForm.valid || !notAnswered)">
      <ng-container *ngIf="isDesktop">
        <div class="sticky-answers">
          <span class="answer-type" *ngIf="firstQuestionEver">Première bonne réponse&nbsp;!</span>
          <span class="answer-type" *ngIf="!firstQuestionEver">Bonne réponse&nbsp;!</span>
          <span>Tu as répondu</span>
          <ng-container *ngFor="let key of objectKeys(questionForm.value); let i = index">
            <ng-container *ngFor="let value of questionForm.value[key]; let j = index">
              <span class="user-answer">{{value}}</span>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="!isDesktop">
        <div class="sticky-answers">
          <div class="answer-type" *ngIf="firstQuestionEver">Première bonne réponse&nbsp;!</div>
          <div class="answer-type" *ngIf="!firstQuestionEver">Bonne réponse&nbsp;!</div>
          <div>Tu as répondu </div>
        </div>
        <div class="sticky-user-answer">
          <ng-container *ngFor="let key of objectKeys(questionForm.value); let i = index">
            <ng-container *ngFor="let value of questionForm.value[key]; let j = index">
              <!-- <b *ngIf="j > 0 && j < questionForm.value[key].length">, </b> -->
              <!-- <b *ngIf="i == (objectKeys(questionForm.value).length - 1) && questionForm.value[objectKeys(questionForm.value)[0]].length > 0 && ((j == 0 && objectKeys(questionForm.value).length > 1) || (objectKeys(questionForm.value).length == 1 && questionForm.value[key].length > 1 && j == (questionForm.value[key].length - 1)))"> et </b> -->
              <span class="user-answer">{{value}}</span>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="userAnswers margin-left-5 fix-zendesk" *ngIf="!answeredValid && (questionForm.valid || !notAnswered)" [ngClass]="{'wrongAnswer': !answeredValid, 'fixWrongAnswer': (!answeredValid && firstQuestionEver)}">
      <ng-container *ngIf="isDesktop">
        <div class="sticky-answers">
          <span class="answer-type" *ngIf="firstQuestionEver">Première erreur (rien de grave)</span>
          <span class="answer-type" *ngIf="!firstQuestionEver">Mauvaise réponse&nbsp;!</span>
          <span>Tu as répondu</span>
          <ng-container *ngFor="let key of objectKeys(questionForm.value); let i = index">
            <ng-container *ngFor="let value of questionForm.value[key]; let j = index">
              <span class="user-answer">{{value}}</span>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="!isDesktop">
        <div class="sticky-answers">
          <div class="answer-type" *ngIf="!firstQuestionEver">Mauvaise réponse&nbsp;!</div>
          <div>Tu as répondu</div>
        </div>
        <div class="sticky-user-answer">
          <ng-container *ngFor="let key of objectKeys(questionForm.value); let i = index">
            <ng-container *ngFor="let value of questionForm.value[key]; let j = index">
              <!-- <b *ngIf="j > 0 && j < questionForm.value[key].length">, </b>
              <b *ngIf="i == (objectKeys(questionForm.value).length - 1) && questionForm.value[objectKeys(questionForm.value)[0]].length > 0 && ((j == 0 && objectKeys(questionForm.value).length > 1) || (objectKeys(questionForm.value).length == 1 && questionForm.value[key].length > 1 && j == (questionForm.value[key].length - 1)))"> et </b> -->
              <span class="user-answer">{{value}}</span>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="userAnswers margin-left-5 fix-zendesk" *ngIf="!answeredValid && !questionForm.valid && notAnswered" [ngClass]="{'wrongAnswer': !answeredValid, 'fixWrongAnswer': (!answeredValid && firstQuestionEver)}">
      Tu n'as pas répondu
    </div>
    <button class="btn full-width" [ngClass]="{'bg-green-300': answeredValid}" (click)="handleNextQuestion()">Continuer</button>
    <!-- <button class="btn full-width" [ngClass]="{'bg-success text-primary': answeredValid}" *ngIf="answerUpdated && answeredValid != null" (click)="handleNextQuestion()">Continuer</button> -->
  </div>
</div>
